import { render, staticRenderFns } from "./ApproversOc.vue?vue&type=template&id=544675c2"
import script from "./ApproversOc.vue?vue&type=script&lang=js"
export * from "./ApproversOc.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports